var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80-80v-481l280-119v80l200-80v120h320v480H80zm80-80h640v-320H480v-82l-200 80v-78l-120 53v347zm280-80h80v-160h-80v160zm-160 0h80v-160h-80v160zm320 0h80v-160h-80v160zm280-320H680l40-320h120l40 320zM160-160h640-640z"
  })));
}
export default Svg24Px;